import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'dvl-food-confirm',
  templateUrl: './food-confirm.component.html'
})
export class DvlFoodConfirmComponent {
  @Input() food: any;
  @Output('reject') rejectEmitter: EventEmitter<void>;
  @Output('confirm') confirmEmitter: EventEmitter<any>;

  constructor() {
    this.food = {};
    this.rejectEmitter = new EventEmitter<void>();
    this.confirmEmitter = new EventEmitter<any>();
  }

  reject(): void {
    this.rejectEmitter.emit();
  }

  confirm(): void {
    this.confirmEmitter.emit(this.food);
  }
}



// WEBPACK FOOTER //
// /Proyectos-Ankaa/proyecto-meriendas-diverland/src/app/reception/components/food-picker/components/food-confirm/food-confirm.component.ts